import React from 'react';
import FormGroup from './FormGroup';
import ImageUploadFormGroup from './ImageUploadFormGroup';
import { storage } from '../../../../firebase';
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import '../../../../styles/BeerForm.scss';

const BeerFormGroup = ({ newItem, setNewItem }) => {

  const handleImageUpload = async (file) => {
    const storageRef = ref(storage, `images/${file.name}`);
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);
    setNewItem({ ...newItem, imageUrl: downloadURL, image: file });
  };

  return (
    <div>
      <FormGroup label="Birrificio" value={newItem.brewery} onChange={(e) => setNewItem({ ...newItem, brewery: e.target.value })} />
      <FormGroup label="Stile" value={newItem.beerStyle} onChange={(e) => setNewItem({ ...newItem, beerStyle: e.target.value })} />
      <FormGroup label="Gradazione" value={newItem.abv} onChange={(e) => setNewItem({ ...newItem, abv: e.target.value })} />

      <ImageUploadFormGroup
        imageUrl={newItem.imageUrl}
        onImageChange={handleImageUpload}
        onImageDelete={() => setNewItem({ ...newItem, imageUrl: '', image: null })}
      />

    </div>
  );
};

export default BeerFormGroup;
